<template>
  <BaseNoticeItem>
    <template #head>
      <strong>{{ $t('You need to enable PAYE for your account.') }}</strong>
    </template>
    <template #body>
      {{ $t('This job can only be paid via PAYE (payroll).') }}
      {{ $t('Are you prepared to work as an employed contractor with taxes handled by Worksome?') }}
      <br />
    </template>
    <template #action>
      <div class="tw-flex tw-justify-between tw-w-full tw-items-center">
        <a href="/pages/faq" target="_blank">{{ $t('Read more in our FAQ') }}</a>

        <a :href="buttonUrl">
          <WdsButton small warning data-test="actionButton">
            {{ $t('Edit profile now') }}
          </WdsButton>
        </a>
      </div>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { WdsButton } from '@worksome/wds-components'
import { computed } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
  hire: {
    type: Object,
    required: true,
  },
  isComplete: {
    type: Boolean,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#business-entity`
})
</script>
